import { BulkChargeJob } from "../types";
import { ConfirmModal } from "./ConfirmModal";

export function BulkChargeModal({
  stage,
  selectedCount,
  job,
  onCancel,
  onConfirm,
  onDone,
}: {
  stage: "confirm" | "progress" | null;
  selectedCount: number;
  job: BulkChargeJob | undefined;
  onCancel: () => void;
  onConfirm: () => void;
  onDone: () => void;
}) {
  if (stage === "confirm") {
    return (
      <ConfirmModal
        title={`Charge ${selectedCount} clients?`}
        actions={[
          { label: "Cancel", onClick: onCancel },
          {
            label: `Confirm — Charge ${selectedCount} Clients`,
            onClick: onConfirm,
            variant: "primary",
          },
        ]}
      >
        This will process charges for all selected clients. Clients that are not
        ready will be skipped.
      </ConfirmModal>
    );
  }

  if (stage === "progress" && job) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-6 max-w-lg w-full">
          {job.status === "processing" ? (
            <>
              <h3 className="text-lg font-semibold mb-4">
                Processing charges...
              </h3>
              <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                <div
                  className="bg-blue-600 h-2 rounded-full transition-all"
                  style={{
                    width: `${(job.processed / job.total) * 100}%`,
                  }}
                />
              </div>
              <p className="text-sm text-gray-500">
                {job.processed} / {job.total} clients processed
              </p>
            </>
          ) : (
            <>
              <h3 className="text-lg font-semibold mb-4">Charge Complete</h3>
              <div className="flex gap-4 mb-4">
                <div className="flex-1 bg-green-50 rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-green-600">
                    {job.succeeded.length}
                  </div>
                  <div className="text-xs text-green-800">Charged</div>
                  <div className="text-xs text-green-700 mt-1">
                    $
                    {job.succeeded
                      .reduce((s, r) => s + r.amount, 0)
                      .toLocaleString()}
                  </div>
                </div>
                <div className="flex-1 bg-amber-50 rounded-lg p-4 text-center">
                  <div className="text-2xl font-bold text-amber-600">
                    {job.skipped.length}
                  </div>
                  <div className="text-xs text-amber-800">Skipped</div>
                </div>
              </div>
              {job.skipped.length > 0 && (
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
                  <div className="text-xs font-semibold text-amber-800 mb-1">
                    Skipped Clients:
                  </div>
                  {job.skipped.map((s) => (
                    <div key={s.userId} className="text-xs text-amber-700">
                      {s.reason}
                    </div>
                  ))}
                </div>
              )}
              <div className="text-center">
                <button
                  onClick={onDone}
                  className="px-6 py-2 bg-black text-white rounded-md text-sm font-semibold"
                >
                  Done
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
}
